import options from './chart.component';

export default {
    selector: 'dtChart',
    options
};
